module.exports = __webpack_public_path__ + "img/inscription-pending.82053cc6.svg";